<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <div class="inventory-info" v-if="backRole('AS_1')">
          <el-select style="width:80px;" v-model="inventoryYear" size="mini" placeholder="盘点时间">
            <el-option v-for="item in inventoryYearArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          年度盘点&nbsp;&nbsp;&nbsp;
          <el-button type="primary" :disabled="disabledStartInventory" @click="startInventory()" size="mini">确认开启
          </el-button>
        </div>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="list-title">
      <el-row>
        <el-col :span="8" style="float:right;margin-top:5px;">
          <el-input v-model="filterKey" size="mini" placeholder="你可以输入筛选资产编号/资产名称进行筛选"></el-input>
        </el-col>
        <el-col :span="12">
          <el-radio-group size="mini" v-model="relateType">
            <el-radio-button label="0">所有资产</el-radio-button>
            <el-radio-button label="1">未盘点资产</el-radio-button>
            <el-radio-button label="2">异常资产</el-radio-button>
            <el-radio-button label="3">盘点正常资产</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
    </div>

    <div class="table-total" v-if="paginationData">
      <ul class="total-ul th-ul">
        <li v-for="item,i in hjsData" :key="i">
          <label>{{ item.status }}</label>
          <div class="cont">
            <span>购置金额：{{ item.priceTotal }}</span>
            <span>净值：{{ item.jzTotal }}</span>
            <span>累计折旧：{{ item.ljzjTotal }}</span>
          </div>
        </li>
      </ul>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="number" label="资产编号" width="160px">
      </el-table-column>
      <el-table-column prop="name" label="资产名称">
      </el-table-column>
      <el-table-column prop="attribute.name" label="资产属性" width="90px">
      </el-table-column>
      <el-table-column prop="spec" label="规格型号" width="140px">
      </el-table-column>
      <!-- <el-table-column prop="manufacturer" label="制造厂商">
      </el-table-column> -->
      <el-table-column prop="price" label="购置金额" width="90px" align="center">
      </el-table-column>
      <!-- <el-table-column prop="amount" label="数量" width="60px" align="center">
      </el-table-column> -->
      <el-table-column prop="purchaseTime" label="购置时间" width="80px">
      </el-table-column>

      <el-table-column label="盘点状态" width="80px" align="center">
        <template slot-scope="scope">
          <strong v-if="scope.row.panStatus==1" style="color:green">盘亏</strong>
          <strong v-else-if="scope.row.panStatus==0" style="color:red">盘盈</strong>
          <strong v-else-if="scope.row.panStatus==2">正常</strong>
          <strong v-else>未登记</strong>
        </template>
      </el-table-column>


      <el-table-column label="详情" width="50px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom">
            <i @click="assetDetail(scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <asset-detail></asset-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import AssetDetail from './assetDetail'
  export default {
    mixins: [Role],
    components: {
      AssetDetail,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        disabledStartInventory: true,
        inventoryYear: '',
        inventoryYearArr: ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028'],
        relateType: "0",

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        hjsData: [],
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],

        // 表格多选
        multipleSelection: []
      }
    },
    created() {
      this.inventoryYear = (new Date()).getFullYear()
    },
    mounted() {
      console.log(this.organization.length > 0)

      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      // 获取列表
      // this.getLists()
      // 获取项目组
      // this.getTeam()
    },
    methods: {
      // 开启盘点
      startInventory() {
        ajax.post('/asset/pan/open', {
          year: this.inventoryYear,
          'depId': this.depId,
        }, (res) => {
          this.$message.success("已开启" + this.inventoryYear + "年度盘点")
          this.getLists()
          this.setDisabledStartInventory()
        })
      },


      // 显示详情
      assetDetail(row) {
        let assetChangeDetail = {
          status: false,
          data: {}
        }
        this.$store.commit('set_assetChangeDetail', assetChangeDetail)

        let assetDetail = {
          status: true,
          data: row
        }
        // console.log(assetDetail)
        this.$store.commit('set_assetDetail', assetDetail)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]
            // let _filterStatus = true
            // if (_filterStatus) {
            if (_project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 ||
              _project.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_project)
            }
            // }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/pan/all/list', {
          'depId': this.depId == 0 ? "" : this.depId,
          'type': this.relateType,
          'year': this.inventoryYear
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.list
          this.hjsData = res.vo.hjs
          this.getPaginationData()
        })
      },
      // 设置是否可以发生盘点
      setDisabledStartInventory() {
        // 请求是否当前年份是否可以发起盘点
        ajax.get('/asset/pan/open/valid', {
          'depId': this.depId == 0 ? "" : this.depId,
          'year': this.inventoryYear
        }, (res) => {
          this.disabledStartInventory = res.vo.data == 0 ? false : true
        })
      },
    },
    watch: {
      'inventoryYear'() {
        // disabledStartInventory
        this.setDisabledStartInventory()
      },
      'depId'() {
        this.getLists()
      },
      'relateType'() {
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/inventoryList.vue